export default __webpack_public_path__ + "static/media/marketing-img-first.3dcc74ad.jpg";